import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/43_sakura/43_sakura"
 * Contains 1 texture(s)
 */
export class Mobile43SakuraAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/43_sakura/43_sakura';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '43_sakura.jpg'
    ] as const;
}
